// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NewCycleSelectHint-container-S4vVE {\n  position: relative;\n  min-width: 250px;\n}\n@media (max-width: 650px) {\n  .NewCycleSelectHint-container-S4vVE {\n    display: none;\n  }\n}\n.NewCycleSelectHint-si-content-width-max-m-AgB8o .NewCycleSelectHint-container-S4vVE {\n  display: none;\n}\n.NewCycleSelectHint-arrow-3zXc2 {\n  position: absolute;\n  top: -18px;\n  left: -5px;\n  height: 12px;\n}\n.NewCycleSelectHint-logo-VmF-T {\n  margin-bottom: -0.4em;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "NewCycleSelectHint-container-S4vVE",
	"si-content-width-max-m": "NewCycleSelectHint-si-content-width-max-m-AgB8o",
	"arrow": "NewCycleSelectHint-arrow-3zXc2",
	"logo": "NewCycleSelectHint-logo-VmF-T"
};
module.exports = exports;
